module.exports = __webpack_public_path__ + "img/03.0a333589.jpg";